// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_jb-0";
export var actionModalContentContainer = "_jb-1";
export var createTagButton = "_jb-2";
export var footerContainer = "_jb-7";
export var fullWidthDivider = "_jb-3";
export var hasCreateTagButton = "_jb-4";
export var noCreateTagButton = "_jb-5";
export var tagsContainer = "_jb-6";
export var tagsModalContentContainer = "_jb-8";